const OffersIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 2"
    viewBox="0 0 24 23.99"
    className={className}
    data-palette="OffersIcon">
    <g data-name="Layer 2">
      <path
        d="M4.96 7.58c-1.21-2.41-.5-5.5 1.58-6.9 1.8-1.21 4.1-.78 5.47 1.04C12.84.63 14.03 0 15.28.01c2.41 0 4.36 2.26 4.36 5.05 0 .89-.2 1.76-.58 2.52H4.96Zm3.78-5.04c-1.2-.02-2.2 1.09-2.21 2.49-.02 1.35.89 2.47 2.05 2.56h2.34V5.06c0-1.25-.79-2.31-1.85-2.5l-.17-.02h-.16Zm6.54 0c-1.14 0-2.09 1.02-2.18 2.34v2.71h2.18c1.14 0 2.09-1.02 2.18-2.34v-.19c0-1.39-.97-2.52-2.18-2.52Z"
        data-name="Layer 1-2"
        fill="var(--brand-bg-primary)"
      />
      <path
        d="M24 7.58v1.34h-2.18v13.81c0 .7-.49 1.26-1.09 1.26H3.27c-.6 0-1.09-.56-1.09-1.26V8.92H0V7.58h24ZM3.76 8.93v13.89h7.15V8.93H3.76Zm16.48 0h-7.15v13.89h7.15V8.93Z"
        data-name="Layer 1-2"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default OffersIcon;
